const initState = {
    error: null,
    status: '',
    progress: null,
    syncList: [],
    syncCancel: false,
    syncCounter: 0,
    syncType: '',
    syncAdmin: false,
}

const syncReducer = (state = initState, action) => {

    switch (action.type) {
        case 'SYNC_CANCEL': return { ...state, status: action.type, error: null, syncCancel: action.payload }
        case 'SYNC_LIST': return { ...state, status: action.type, error: null, syncList: action.payload }
        case 'SYNC_COUNTER': return { ...state, status: action.type, error: null, syncCounter: action.payload }

        case 'SYNC_PORTFOLIO_PENDING': return { ...state, status: action.type, error: null, syncCancel: false, syncCounter: 0 }
        case 'SYNC_PORTFOLIO_ERROR': return { ...state, status: action.type, error: 'sync error!' }
        case 'SYNC_PORTFOLIO_SUCCESS': return { ...state, status: action.type, error: null }
        case 'SYNC_PORTFOLIO_PROGRESS': return { ...state, status: action.type, error: null, progress: action.payload }

        case 'SYNC_COMMON_PENDING': return { ...state, status: action.type, error: null, syncCancel: false, syncCounter: 0 }
        case 'SYNC_COMMON_ERROR': return { ...state, status: action.type, error: 'Documents error!' }
        case 'SYNC_COMMON_SUCCESS': return { ...state, status: action.type, error: null }
        case 'SYNC_COMMON_PROGRESS': return { ...state, status: action.type, error: null, progress: action.payload }

        case 'PRELOAD_PDF_PENDING': return { ...state, status: action.type, error: null }
        case 'PRELOAD_PDF_ERROR': return { ...state, status: action.type, error: 'preload PdfWorker error!' }
        case 'PRELOAD_PDF_SUCCESS': return { ...state, status: action.type, error: null }

        case "SET_SYNC_TYPE": return { ...state, syncType: action.payload }
        case "SET_SYNC_ADMIN": return { ...state, syncAdmin: action.payload }

        default: return state;
    }
};

export default syncReducer;